module.exports = __webpack_public_path__ + "./images/32f3b887eeff1b21e6337188381a8b95.jpg";